// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import vSelect from 'vue-select';

import { BootstrapVue } from 'bootstrap-vue';
// import { BNavbar, BButton, BLink, BContainer, BCol, BRow, BAlert, BNavbarToggle, BCollapse, BNavbarBrand, BNavbarNav, BModal, BCard, BForm, BFormGroup, BFormInput, BTable, VBToggle } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import Loader from '@/components/widgets/Loader';
import VueMasonry from 'vue-masonry-css';
import 'vue-select/dist/vue-select.css';
import LoadScript from 'vue-plugin-load-script';
import VueAnalytics from 'vue-analytics';

import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faExternalLinkAlt, faUser, faChevronLeft, faCheck, faCreditCard, faCaretDown, faFileInvoiceDollar, faEllipsisV, faChevronRight, faPlus, faHome, faTruck, faTshirt, faKey, faFileCsv, faShoppingCart, faThumbsUp, faThumbsDown, faUpload, faFile, faTimes, faQuestion, faDollarSign, faMobile, faEnvelope, faThumbtack, faBars, faSignOutAlt, faSyncAlt, faHeart, faChevronUp, faChevronDown, faEllipsisH, faTh, faThLarge, faFingerprint, faRedo, faCaretLeft } from '@fortawesome/free-solid-svg-icons';
import { faCcMastercard, faCcVisa, faFacebook, faInstagram, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

Vue.component('v-select', vSelect);

library.add(faCaretLeft, faFingerprint, faExternalLinkAlt, faTh, faThLarge, faCcVisa, faCcMastercard, faHeart, faSyncAlt, faBars, faSignOutAlt, faMobile, faEnvelope, faThumbtack, faDollarSign, faUser, faInstagram, faTwitter, faFacebook, faChevronLeft, faChevronUp, faChevronDown, faCheck, faCreditCard, faCaretDown, faFileInvoiceDollar, faEllipsisV, faEllipsisH, faChevronRight, faPlus, faHome, faTruck, faTshirt, faKey, faFileCsv, faShoppingCart, faThumbsUp, faThumbsDown, faUpload, faCheck, faFile, faTimes, faQuestion, faRedo);
Vue.component('font-awesome-icon', FontAwesomeIcon);

dom.watch();
Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(Loader);
Vue.use(VueMasonry);
Vue.use(LoadScript);

Vue.use(VueAnalytics, {
  id: 'UA-221726265-1',
  router,
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js